import { http } from '@/http/axios.js';

// 管理员列表
export function getAdminListAPI(params) {
  return http({
    url: `/adminapi/user/list`,
    method: 'get',
    params
  })
}
// 部门树
export function getDeptTree() {
  return http({
    url: '/adminapi/dept/tree',
    method: 'get'
  })
}
// 角色列表
export function getRoleList(params) {
  return http({
    url: '/adminapi/role/page',
    method: 'GET',
    params
  })
}
// 申请记录
export function getMemberProductApplyListAPI(params) {
  return http({
    url: '/adminapi/member/apply/product/page',
    method: 'get',
    params
  })
}
